import { Navigate, Route } from 'react-router-dom';
import { apiDocsPlugin, ApiExplorerPage } from '@backstage/plugin-api-docs';
import {
  CatalogEntityPage,
  CatalogIndexPage,
  catalogPlugin,
} from '@backstage/plugin-catalog';
import {
  CatalogImportPage,
  catalogImportPlugin,
} from '@backstage/plugin-catalog-import';
import { ScaffolderPage, scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { orgPlugin } from '@backstage/plugin-org';
import { SearchPage } from '@backstage/plugin-search';
import {
  TechDocsIndexPage,
  techdocsPlugin,
  TechDocsReaderPage,
} from '@backstage/plugin-techdocs';
import { TechDocsAddons } from '@backstage/plugin-techdocs-react';
import { ReportIssue } from '@backstage/plugin-techdocs-module-addons-contrib';
import { UserSettingsPage, UserSettingsAuthProviders, ProviderSettingsItem } from '@backstage/plugin-user-settings';
import { apis,giteaAuthApiRef } from './apis';
import { entityPage } from './components/catalog/EntityPage';
import { searchPage } from './components/search/SearchPage';
import { Root } from './components/Root';

import {
  AlertDisplay,
  OAuthRequestDialog,
  SignInPage,
} from '@backstage/core-components';
import { createApp } from '@backstage/app-defaults';
import { AppRouter, FlatRoutes } from '@backstage/core-app-api';
import { CatalogGraphPage } from '@backstage/plugin-catalog-graph';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { catalogEntityCreatePermission } from '@backstage/plugin-catalog-common/alpha';
import { NotificationsPage } from '@backstage/plugin-notifications';
import { SignalsDisplay } from '@backstage/plugin-signals';
import { AnnouncementsPage } from '@backstage-community/plugin-announcements';
import { HomepageCompositionRoot } from '@backstage/plugin-home';
import { homePage } from './components/home/HomePage';
import { QetaPage } from '@drodil/backstage-plugin-qeta';
import jenkinsPlugin from '@backstage-community/plugin-jenkins/alpha';
/**
import { 
  SignInProviderConfig
} from '@backstage/core-components';

 */
import { githubAuthApiRef ,gitlabAuthApiRef,} from '@backstage/core-plugin-api';
import Star from '@material-ui/icons/Star';
import { infisicalPlugin } from '@infisical/backstage-plugin-infisical';

const app = createApp({
  
  apis,
  bindRoutes({ bind }) {
    bind(catalogPlugin.externalRoutes, {
      createComponent: scaffolderPlugin.routes.root,
      viewTechDoc: techdocsPlugin.routes.docRoot,
      createFromTemplate: scaffolderPlugin.routes.selectedTemplate,
    });
    bind(apiDocsPlugin.externalRoutes, {
      registerApi: catalogImportPlugin.routes.importPage,
    });
    bind(scaffolderPlugin.externalRoutes, {
      registerComponent: catalogImportPlugin.routes.importPage,
      viewTechDoc: techdocsPlugin.routes.docRoot,
    });
    bind(orgPlugin.externalRoutes, {
      catalogIndex: catalogPlugin.routes.catalogIndex,
    });
    
  },

  /**
   * 
   *   components: {
    SignInPage: props => (
      <SignInPage
        {...props}
        auto
      provider={{
        id: 'github-auth-provider',
        title: 'GitHub',
        message: 'Sign in using GitHub',
        apiRef: githubAuthApiRef,
      }}
      />
    ),
  },
});
   * 
   */


components: {
  SignInPage: props => (
    <SignInPage
      {...props}
      providers={[
        {
          id: 'gitlab-auth-provider',
          title: 'GitLab Soltel AMS',
          message: 'Inicia sesión con tu cuenta',
          apiRef: gitlabAuthApiRef,
           },
        {
          id: 'gitea-auth-provider',
          title: 'Gitea AMS Sectorial',
          message: 'Inicia sesión con tu cuenta',
          apiRef: giteaAuthApiRef,
        },
        
      ]}
      title="Elige cómo iniciar sesión"
      align="center"
    />
  ),
  
},

  plugins: [
    // ... other plugins
    infisicalPlugin
  ],
  
});
process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";



const routes = (
  <FlatRoutes>
    {/* <Route path="/" element={<CatalogIndexPage />} /> */}
    <Route path="/" element={<HomepageCompositionRoot />}>
      {homePage}
    </Route>;


    <Route path="/catalog" element={<CatalogIndexPage initialKind="domain" />} />
    <Route
      path="/catalog/:namespace/:kind/:name"
      element={<CatalogEntityPage />}
    >
      {entityPage}
    </Route>
    <Route path="/docs" element={<TechDocsIndexPage />} />
    <Route
      path="/docs/:namespace/:kind/:name/*"
      element={<TechDocsReaderPage />}
    >
      <TechDocsAddons>
        <ReportIssue />
      </TechDocsAddons>
    </Route>
    <Route path="/create" element={<ScaffolderPage />} />
    <Route path="/api-docs" element={<ApiExplorerPage />} />
    <Route
      path="/catalog-import"
      element={
        <RequirePermission permission={catalogEntityCreatePermission}>
          <CatalogImportPage />
        </RequirePermission>
      }
    />
    <Route path="/search" element={<SearchPage />}>
      {searchPage}
    </Route>

    <Route
      path="/settings"
      element={
        <UserSettingsPage
          providerSettings={
        <>
          <ProviderSettingsItem
            title="GitLab Soltel AMS"
            description="Inicia sesión con tu cuenta"
            apiRef={gitlabAuthApiRef}
            icon={Star}
          />
          <ProviderSettingsItem
            title="Gitea AMS Sectorial"
            description="Inicia sesión con tu cuenta"
            apiRef={giteaAuthApiRef}
            icon={Star}
          />
        </>
          }
        />
      }
    />


    <Route path="/catalog-graph" element={<CatalogGraphPage />} />
    <Route path="/notifications" element={<NotificationsPage />} />
    <Route path="/announcements" element={<AnnouncementsPage />} />
    <Route path="/qeta" element={<QetaPage title="Questions" />} />


  </FlatRoutes>
);
process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";
export default app.createRoot(
  <>
    <AlertDisplay />
    <OAuthRequestDialog />
    <SignalsDisplay />
    <AppRouter>
      <Root>{routes}</Root>
    </AppRouter>
  </>,
);



